export const ORGANIZATIONS = "organizations" as const;
export const ADD_USER = "add-user" as const;
export const INVITATIONS = "invitations" as const;
export const COLLECTIONS = "collections" as const;
export const REMOVE_USER = "remove-user" as const;
export const REMOVE_USER_ADMIN = "remove-user-admin" as const;
export const COLLECTIONS_GET_USERS = "collections-get-users" as const;